import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Login.css';
import { getRegionSuffixInUrlSearch, saveRegion } from '../../utils/region';
import Backend from '../../backend';
import _ from 'lodash';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Box,
  Checkbox
} from '@mui/material';
import { getProFlagFromLocalStorage, ShortSubscriptions } from '../../utils/user-subscription';
import { getSearchParam } from '../../utils/url';
import ProCornerTriangle from '../../components/CornerTriangle/ProCornerTriangle';
import { SlideTransition } from '../../components/Transition/Transition';
import { formatEmail, isEmailValid } from '../../utils/email';
import { switchLanguage, tryTranslate } from '../../utils/locale';
import { ERROR, INIT, LOADING, SUCCESS } from '../../constants/phase';
import IconToast from '../../components/NewToast';
import { shouldShowWelcomeDialog, isUserConnected, getUserLogo } from '../../utils/user';
import { getDefaultRoute, getSearchObject } from '../../utils/router';
import { LOGIN_BANNER_IMG } from '../../constants/images';
import NativeOrWeb from '../../utils/native';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY } from '../../constants/session';
import VerifyDialog from './VerifyDialog/VerifyDialog';
import LoginBannerContainer from '../../components/LoginBannerContainer/LoginBannerContainer';
import { withStyles } from 'tss-react/mui';
import LoginStyles from './LoginStyles';
import TermsAndPolicyTypography from '../../components/TermsAndPolicyTypography/TermsAndPolicyTypography';
import { ADVISER_LOGO_FUNCTIONS } from '../../constants/user';
import LoginLockAnim from './LoginLockAnim/LoginLockAnim';
import EmailVerificationModal from '../../components/EmailVerificationModal/EmailVerificationModal';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { requestOneTimeCode } from '../../store/user/api';
import WechatLoginButton from './WechatLoginButton/WechatLoginButton';
import AppleLoginButton from './AppleLoginButton/AppleLoginButton';
import GoogleLoginButton from './GoogleLoginButton/GoogleLoginButton';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

const REVISION = process.env.REVISION;
if (REVISION) {
  console.log(REVISION);
}

const LargeATypographyContainerStyle = { textAlign: 'center' };
const LargeATypographyStyle = {
  fontWeight: 'bold',
  textDecoration: 'underline',
  cursor: 'pointer'
};
export const LargeATypography = props => {
  const { ...rest } = props;
  return (
    <div style={LargeATypographyContainerStyle}>
      <Typography component="span" color="primary" style={LargeATypographyStyle} {...rest} />
    </div>
  );
};

class LoginForm extends PureComponent {
  constructor(props) {
    super(props);

    NativeOrWeb.getStorage('teamShortName')
      .then(teamShortName => {
        this.teamShortNameGot = true;
        if (teamShortName) {
          const logoUri = Backend.api('logo') + `/${teamShortName}`;
          const userLogo = getUserLogo(props.userDetails, logoUri, ADVISER_LOGO_FUNCTIONS.LOGIN);
          this.setState({ logoUri: userLogo, ready: false });
        } else {
          this.setState({ ready: true });
        }
      })
      .catch();

    let isPro = getProFlagFromLocalStorage();
    const proInSearch = getSearchParam(this.props.location.search, 'pro');
    if (proInSearch !== null && proInSearch !== 'false' && proInSearch !== 'undefined') {
      isPro = true;
    }

    localStorage.removeItem('clientId');

    const searchObject = getSearchObject(props.history);
    const email = _.get(searchObject, 'email');

    this.state = {
      email: email || '',
      password: '',
      pendingApprovalModal: false,
      emailNotVerifiedModal: false,
      err: {},
      nextLocation: undefined,
      accountLockedModal: false,
      logoUri: LOGIN_BANNER_IMG,
      isPro: isPro,
      showTimeoutModal: this.props.timeout ? true : false,
      inputDisabled: false,
      forceDisableBioAuth: false,
      verifyDialog: false,
      lastUserEmail: undefined,
      lastUserName: undefined,
      ready: false,
      lockAnimStatus: 'init',
      loginMode: 'password', // 'password' or 'otc'
      otc: '',
      otcRequested: false,
      otcCooldown: 0,
      staySignedIn: true
    };
    this.closePendingApprovalModal = this.closePendingApprovalModal.bind(this);
    this.closeEmailNotVerifiedModal = this.closeEmailNotVerifiedModal.bind(this);
    this.closeAccountLockedModal = this.closeAccountLockedModal.bind(this);
    this.redirectToLinker = this.redirectToLinker.bind(this);
  }

  onBannerLoad = () => {
    if (this.teamShortNameGot) {
      this.setState({ ready: true });
    }
  };

  UNSAFE_componentWillMount() {
    const { history, location } = this.props;

    // Handle WeChat web OAuth callback
    const searchParams = new URLSearchParams(location.search);
    const wechatCode = searchParams.get('code');
    const wechatState = searchParams.get('state');
    if (wechatCode && wechatState === 'pfplus_wechat_login') {
      this.wechatWebCode = wechatCode;
    }

    // check whether nextUrl is set via location

    let nextLocation = undefined;
    if (location.search.includes('next=')) {
      nextLocation = new URLSearchParams(location.search).get('next');
    } else if (location.state && location.state.from) {
      nextLocation = location.state.from;
    } else if (location.nextUrl) {
      nextLocation = location.nextUrl;
    } else if (location.state && location.state.nextUrl) {
      nextLocation = location.state.nextUrl;
    }

    let showTimeoutModal = this.state.showTimeoutModal;
    if (location.state && location.state.timeout) {
      showTimeoutModal = location.state.timeout;
    }

    if (!nextLocation) {
      history.replace();
    }

    // save formatted region got from url search to local storage
    saveRegion(getRegionSuffixInUrlSearch(this.props.location.search));

    this.setState({ nextLocation: nextLocation, showTimeoutModal });
  }

  autoTryBiometricLogin = async verifyDialog => {
    if (!sessionStorage.getItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY)) {
      this.biometricLogin(verifyDialog).then().catch();
    } else {
      this.setState({ inputDisabled: false });
    }
  };

  verifyLogout = async () => {
    const { handleSignOut } = this.props;
    handleSignOut(null, true, true);
    this.setState({ verifyDialog: false, inputDisabled: false });
  };

  cancelVerification = async () => {
    this.setState({ verifyDialog: false, inputDisabled: false });
  };

  verifyPassword = async password => {
    const { loginUser } = this.props;
    const { lastUserEmail, staySignedIn } = this.state;
    this.isBiometricLogin = false;
    loginUser({ email: lastUserEmail, password: password, staySignedIn });
  };

  async componentDidMount() {
    // Trigger WeChat web login if callback code was captured
    if (this.wechatWebCode) {
      this.props.loginUser({ wechatWebCode: this.wechatWebCode, staySignedIn: this.state.staySignedIn });
      this.wechatWebCode = null;
    }

    const { intl, isBiometricSet, isAuthenticated, authenticatedUser } = this.props;
    const { email } = this.state;
    /*to display the page language as per the browser language*/
    var user = this.props.userDetails;
    if (_.isEmpty(user)) {
      // var userLang = navigator.language || navigator.userLanguage;
      // const language = userLang === 'zh-HK' ? 'zh-Hant-HK' : userLang === 'zh-CN' ? 'zh' : 'en';
      // this.props.selectedLocale(language);
    }

    // const isIos = () => {
    //   const userAgent = window.navigator.userAgent.toLowerCase();
    //   return /iphone|ipad|ipod/.test(userAgent);
    // };
    // Detects if device is in standalone mode
    // const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    // if (isIos() && isInStandaloneMode()) {
    //   toast.info(
    //     IconToast(
    //       'info',
    //       'Due to IOS limitation, the APP would reload everytime. To avoid, go app.portfoplus.com use Safari.'
    //     ),
    //     { className: 'new-toast' }
    //   );
    // }

    // PWA install prompt
    // if (!window.matchMedia('(display-mode: standalone)').matches && !sessionStorage.getItem('pwaInstalled')) {
    //   toast.info(
    //     IconToast('pwa', intl.formatMessage({ id: 'add-to-home' }), () =>
    //       window.open('http://bit.ly/pfpicon', '_blank')
    //     ),
    //     {
    //       className: 'new-toast',
    //       onClick: () => window.open('http://bit.ly/pfpicon', '_blank'),
    //       autoClose: 15000
    //     }
    //   );
    // }

    window.addEventListener('appinstalled', event => {
      sessionStorage.setItem('pwaInstalled', 'true');
    });

    if (!!isAuthenticated) {
      const shortSubscriptions = new ShortSubscriptions(_.get(authenticatedUser, 'subscriptions', []));

      if (!this.historyPushObject) {
        if (shortSubscriptions.containValidCoreSubscription()) {
          sessionStorage.setItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY, 'true');
          this.setState({
            inputDisabled: true,
            verifyDialog: false,
            lockAnimStatus: LOADING
          });
          await this.continueLogin(this.props);
          this.setState({
            lastUserEmail: undefined,
            lastUserName: undefined,
            lockAnimStatus: SUCCESS
          });
        }
      }
    } else {
      // Native flow
      if (!email) {
        let lastUserEmail = await NativeOrWeb.getUserEmail();
        if (lastUserEmail) {
          lastUserEmail = (lastUserEmail || '').trim().toLowerCase();
          const lastUserName = ((await NativeOrWeb.getUserName()) || '').trim().toLowerCase();
          const credentials = await NativeOrWeb.getBiometricCredentials();
          if (credentials && credentials.username) {
            const credentialsUsername = (credentials.username || '').trim().toLowerCase();
            if (isBiometricSet && lastUserEmail === credentialsUsername) {
              this.setState({
                lastUserEmail: lastUserEmail,
                lastUserName: lastUserName,
                inputDisabled: true
              });
              this.autoTryBiometricLogin(true).then().catch();
            } else {
              this.setState({
                verifyDialog: true,
                lastUserEmail: lastUserEmail,
                lastUserName: lastUserName,
                inputDisabled: true
              });
            }
          } else {
            this.setState({
              verifyDialog: true,
              lastUserEmail: lastUserEmail,
              lastUserName: lastUserName,
              inputDisabled: true
            });
          }
        } else {
          // if (isBiometricSet) {
          //   this.autoTryBiometricLogin()
          //     .then()
          //     .catch();
          // }
        }
      }
    }
  }

  redirectToLinker(subscriptions) {
    const containLinkerSubscription = new ShortSubscriptions(subscriptions).containLinkerSubscription();
    const containProSubscription = new ShortSubscriptions(subscriptions).containProSubscription();
    if (!containLinkerSubscription && !containProSubscription) {
      const linkerUrl = process.env.LINKER_URL;
      const nextPath = window.location.search?.split('path=')[1]?.split('&')[0];
      if (linkerUrl) {
        const nextUrl = [linkerUrl, nextPath].join('');
        window.location.href = nextUrl;
        return;
      }
      return;
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const { intl, loginMessage, loginPhase, userDetails, subscriptions, authenticatedUser, history } = this.props;

    const obj = {};

    if (loginPhase === false && prevProps.loginPhase !== false) {
      sessionStorage.setItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY, 'true');

      if (Capacitor.getPlatform() === 'web' && loginMessage === 'wechat-not-bound') {
        const params = new URLSearchParams({ campaignCode: 'wechat' });
        history.push(`/userType?${params.toString()}`);
        return;
      }

      if (this.isBiometricLogin) {
        await NativeOrWeb.disableBiometricAuth();
        this.setState({ forceDisableBioAuth: true });
        alert(intl.formatMessage({ id: 'biometric-re-enable' }));
      }
      if (_.get(this.props, 'userDetails.passwordAttempt') && _.get(this.props, 'userDetails.passwordAttempt') > 5) {
        obj.accountLockedModal = true;
      }
      obj.verifyDialog = false;
      obj.lastUserEmail = undefined;
      obj.lastUserName = undefined;
      obj.lockAnimStatus = ERROR;
    } else if (
      (loginPhase === 'pending_approval' || loginPhase === 'email_not_verified') &&
      prevProps.loginPhase !== 'pending_approval' &&
      prevProps.loginPhase !== 'email_not_verified'
    ) {
      sessionStorage.setItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY, 'true');

      if (loginPhase === 'pending_approval') {
        obj.pendingApprovalModal = true;
        obj.emailNotVerifiedModal = false;
        obj.email = '';
      } else {
        obj.pendingApprovalModal = false;
        obj.emailNotVerifiedModal = true;
        obj.email = this.state.email;
      }
      obj.password = '';
      obj.verifyDialog = false;
      obj.lastUserEmail = undefined;
      obj.lastUserName = undefined;
      obj.lockAnimStatus = INIT;
    } else if (loginPhase === true && prevProps.loginPhase !== true) {
      sessionStorage.setItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY, 'true');

      obj.inputDisabled = true;
      obj.verifyDialog = false;
      obj.lastUserEmail = undefined;
      obj.lastUserName = undefined;

      const isLinkerFreemium = new ShortSubscriptions(subscriptions).containLinkerFreeSubscription();
      if (!(subscriptions.length > 0 && !userDetails.emailVerified) || isLinkerFreemium) {
        obj.lockAnimStatus = SUCCESS;
        const promises = [this.continueLogin(this.props)];

        const { email, password } = this.state;
        if (email && password) {
          promises.push(NativeOrWeb.askBiometricAuth(email, password));
        }
        await Promise.all(promises);
      }
    } else if (loginPhase === LOADING && prevProps.loginPhase !== LOADING) {
      obj.lockAnimStatus = LOADING;
    }
    if (!prevProps.authenticatedUser && authenticatedUser) {
      if (this.state.nextLocation === 'linker') {
        this.redirectToLinker(subscriptions);
      } else if (this.state.nextLocation) {
        switchLanguage(this.props.selectedLocale, this.props.userDetails.language);
        const nextLocation = this.state.nextLocation;
        if (typeof nextLocation === 'string') {
          history.push(nextLocation);
        } else {
          history.push({
            pathname: nextLocation.pathname,
            search: nextLocation.search || '',
            hash: nextLocation.hash || '',
            state: nextLocation.state
          });
        }
      }
    }

    this.setState(obj);
  }

  biometricLogin = async verifyDialog => {
    try {
      sessionStorage.setItem(AUTO_TRIED_BIOMETRIC_LOGIN_SESSION_KEY, 'true');

      const { loginUser } = this.props;
      let credentials = await NativeOrWeb.getBiometricCredentialsWithVerification();
      if (credentials && credentials.username && credentials.password) {
        this.isBiometricLogin = true;
        this.setState({ inputDisabled: false });
        loginUser({
          email: credentials.username,
          password: credentials.password,
          staySignedIn: this.state.staySignedIn
        });
      } else {
        if (verifyDialog === true) {
          credentials = await NativeOrWeb.getBiometricCredentials();
          if (credentials) {
            this.setState({
              lastUserEmail: credentials.username,
              verifyDialog: true,
              inputDisabled: true
            });
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  async continueLogin(nextProps) {
    const {
      userDetails,
      setShownDashHelp,
      currencyExchangeRate,
      loginFetch,
      updateFirstGuidelineState,
      shortSubscriptions
    } = nextProps;

    if (nextProps.exchangeRate && _.isEmpty(nextProps.exchangeRate)) {
      currencyExchangeRate();
    }

    const showAdviserBlast = userDetails.userType === 'User';
    loginFetch(userDetails._id, userDetails.userType, {
      state: { showAdviserBlast: showAdviserBlast }
    });

    // sending the welcome message , remind target & reminderTarget(to show the popup of reminder) on dashboard so that they display only once when user is login
    // logic to display the welcome message , reminder target and reminder popup
    var birthdayPopUp = userDetails.userType === 'Adviser' ? true : false;
    let routePath = getDefaultRoute(userDetails);
    let path = userDetails.hideWelcome ? routePath : '/welcome';
    var welcomeMessage = shouldShowWelcomeDialog(userDetails);
    var remindTarget = userDetails.userType === 'Adviser' && !welcomeMessage ? userDetails.remindTarget : false;
    if (userDetails.userType === 'User' && !isUserConnected(userDetails)) {
      setShownDashHelp(false);
    } else if (userDetails.userType === 'Adviser') {
    }
    updateFirstGuidelineState(false);

    const nextLocation = this.state.nextLocation;
    if (nextLocation && nextLocation !== 'linker') {
      // Honour the pre-login destination. animationEnd always pushes
      // historyPushObject, which used to overwrite nextLocation with
      // dashboard/welcome — so an existing client clicking an invitation
      // while logged out never reached the accept dialog.
      this.historyPushObject =
        typeof nextLocation === 'string'
          ? { pathname: nextLocation }
          : {
              pathname: nextLocation.pathname,
              search: nextLocation.search || '',
              hash: nextLocation.hash || '',
              state: nextLocation.state
            };
    } else {
      this.historyPushObject = {
        pathname: path,
        state: {
          remindTarget: remindTarget,
          welcomeMessage: welcomeMessage,
          birthdayPopUp: birthdayPopUp,
          showAdviserBlast: showAdviserBlast,
          showTeamBlast: userDetails.userType === 'Adviser',
          noBackButton: true,
          loginRedirect: true,
          nextUrl: undefined
        }
      };
    }

    setTimeout(() => {
      if (this.state.nextLocation !== undefined && this.state.nextLocation !== 'linker') {
        this.setState({ nextLocation: undefined });
        this.props.history.push(this.state.nextLocation);
      }
    }, 0);
  }

  handleChange(e) {
    if (e.target.name === 'email') {
      delete this.state.err.email;
    }
    if (e.target.name === 'password') {
      delete this.state.err.password;
    }
    if (e.target.name === 'otc') {
      delete this.state.err.otc;
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  toggleLoginMode = () => {
    const newMode = this.state.loginMode === 'password' ? 'otc' : 'password';
    this.setState({
      loginMode: newMode,
      password: '',
      otc: '',
      err: {}
    });
  };

  async requestOTC(event) {
    event.preventDefault();
    const { intl } = this.props;
    const err = {};

    if (this.state.email === '' || this.state.email.trim() === '') {
      err.email = 'Email is required';
    } else if (!isEmailValid(this.state.email)) {
      err.email = 'Invalid email';
    }

    this.setState({ err });

    if (!Object.keys(err).length) {
      try {
        const result = await requestOneTimeCode(formatEmail(this.state.email), intl.locale);

        if (result.success) {
          this.setState({ otcRequested: true });
          this.startOtcCooldown();
          toast.info(IconToast('success', intl.formatMessage({ id: 'email-has-been-sent' })), {
            className: 'new-toast'
          });
        } else {
          toast.info(IconToast('error', intl.formatMessage({ id: 'failed-to-send-email' })), {
            className: 'new-toast'
          });
        }
      } catch (error) {
        toast.info(IconToast('error', intl.formatMessage({ id: 'failed-to-send-email' })), {
          className: 'new-toast'
        });
      }
    }
  }

  async submitForm(event) {
    event.preventDefault();
    const { inputDisabled, loginMode } = this.state;
    if (inputDisabled) {
      return;
    }
    const { loginUser } = this.props;
    const err = {};
    if (this.state.email === '' || this.state.email.trim() === '') {
      err.email = 'Email is required';
    } else if (!isEmailValid(this.state.email)) {
      err.email = 'Invalid email';
    }

    if (loginMode === 'password') {
      if (this.state.password === '' || this.state.password.trim() === '') {
        err.password = 'Password is required';
      }
    } else {
      // OTC mode
      if (this.state.otc === '' || this.state.otc.trim() === '') {
        err.otc = 'please-enter-one-time-code';
      }
    }

    this.setState({ err });
    if (!Object.keys(err).length) {
      var postData = {};
      postData.email = formatEmail(this.state.email);

      if (loginMode === 'password') {
        postData.password = this.state.password.trim();
      } else {
        postData.oneTimeCode = this.state.otc.trim();
      }

      postData.staySignedIn = this.state.staySignedIn;
      this.setState({ inputDisabled: true });
      this.isBiometricLogin = false;
      loginUser(postData);
    }
  }

  closePendingApprovalModal() {
    this.setState({
      pendingApprovalModal: false
    });
  }

  closeEmailNotVerifiedModal() {
    this.setState({
      emailNotVerifiedModal: false
    });
  }

  closeAccountLockedModal() {
    this.setState({
      accountLockedModal: false
    });
    this.props.history.push({
      pathname: '/forgot_password'
    });
  }

  animationEnd = status => {
    const { intl, loginMessage, loginMessageExtras } = this.props;
    if (status === SUCCESS) {
      const { history, location, userDetails, selectedLocale, checkIsBiometricSet } = this.props;
      const { forceDisableBioAuth } = this.state;
      if (this.historyPushObject) {
        const replaceLocation = _.omit(location, ['state.from', 'nextUrl']);
        history.replace(replaceLocation);
        history.push(this.historyPushObject);
        switchLanguage(selectedLocale, userDetails.language);
        if (forceDisableBioAuth) {
          checkIsBiometricSet();
        }
      }
    } else if (status === ERROR) {
      if (
        loginMessage !== 'wechat-not-bound' &&
        loginMessage !== 'apple-not-bound' &&
        loginMessage !== 'google-not-bound'
      ) {
        toast.info(IconToast('error', intl.formatMessage({ id: loginMessage }, loginMessageExtras)), {
          className: 'new-toast'
        });
      }
      this.setState({ inputDisabled: false });
    } else if (status === LOADING) {
      this.setState({ inputDisabled: true });
    }
  };

  componentWillUnmount() {
    if (this._otcCooldownTimer) {
      clearInterval(this._otcCooldownTimer);
    }
  }

  startOtcCooldown() {
    this.setState({ otcCooldown: 30 });
    this._otcCooldownTimer = setInterval(() => {
      this.setState(prev => {
        if (prev.otcCooldown <= 1) {
          clearInterval(this._otcCooldownTimer);
          return { otcCooldown: 0 };
        }
        return { otcCooldown: prev.otcCooldown - 1 };
      });
    }, 1000);
  }

  closeTimeoutModal = () => this.setState({ showTimeoutModal: false });

  /* closeEmailVerfiyModal() {
              this.setState({
                emailVerfiyModal: false
              });
              }*/

  /* resendEmailVerification(){
              let obj = {}
              const {approveUser} = this.props
              obj.email = _.get(this.state,'email','')
              obj.resendVerification = 'resendVerification'
              approveUser(obj)
              }
          */
  render() {
    const { history, intl, isBiometricSet } = this.props;
    const {
      logoUri,
      isPro,
      nextLocation,
      inputDisabled,
      forceDisableBioAuth,
      verifyDialog,
      lastUserEmail,
      lastUserName,
      ready
    } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        {REVISION && <div className={classes.revisionTag}>{REVISION}</div>}
        <VerifyDialog
          open={verifyDialog}
          email={lastUserEmail}
          name={lastUserName}
          onLogout={this.verifyLogout}
          onCancel={this.cancelVerification}
          onSubmit={this.verifyPassword}
        />
        <Dialog
          open={this.state.showTimeoutModal}
          onClose={this.closeTimeoutModal}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          slots={{
            transition: SlideTransition
          }}
        >
          <DialogTitle id="alert-dialog-slide-title">{intl.formatMessage({ id: 'timeout-title' })}</DialogTitle>
          <DialogContent>{intl.formatMessage({ id: 'timeout-content' })}</DialogContent>
          <DialogActions>
            <Button onClick={this.closeTimeoutModal} color="primary">
              {intl.formatMessage({ id: 'OK' })}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.pendingApprovalModal}
          onClose={this.closependingApprovalModal}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          slots={{
            transition: SlideTransition
          }}
        >
          <DialogTitle id="alert-dialog-slide-title">{intl.formatMessage({ id: 'Pending Approval' })}</DialogTitle>
          <DialogContent>{tryTranslate(intl, this.props.loginMessage, this.props.loginMessageExtras)}</DialogContent>
          <DialogActions>
            <Button onClick={this.closependingApprovalModal} color="primary" autoFocus>
              {intl.formatMessage({ id: 'OK' })}
            </Button>
          </DialogActions>
        </Dialog>
        <EmailVerificationModal history={history} open={this.state.emailNotVerifiedModal} email={this.state.email} />
        <Dialog
          open={this.state.accountLockedModal}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
          slots={{
            transition: SlideTransition
          }}
        >
          <DialogTitle id="alert-dialog-slide-title">{intl.formatMessage({ id: 'Account Locked' })}</DialogTitle>
          <DialogContent>
            {this.props.loginMessage
              ? intl.formatMessage({ id: 'account_locked_message' }, this.props.loginMessageExtras)
              : ''}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeAccountLockedModal} color="primary" autoFocus>
              {intl.formatMessage({ id: 'Reset Password' })}
            </Button>
          </DialogActions>
        </Dialog>
        <LoginBannerContainer src={logoUri} loginBanner={true} ready={ready} onLoad={this.onBannerLoad}>
          <ProCornerTriangle explicitShow={isPro} />

          {/*<LoginBannerImage src={logoUri} ready={ready} onLoad={this.onBannerLoad} />*/}

          <Grid size={12}>
            <div className={classes.paper}>
              <Typography
                component="h1"
                variant="h3"
                className={`${classes.desktopLoginwrapper} stagger-item stagger-delay-1`}
              >
                {intl.formatMessage({ id: 'Sign In' })}
              </Typography>
              <div className="stagger-item stagger-delay-1" style={{ marginBottom: 12 }}>
                <LoginLockAnim status={this.state.lockAnimStatus} onCompleteAnimation={this.animationEnd} />
              </div>
              {nextLocation && (
                <Typography color="error" style={{ fontWeight: 500 }} className="stagger-item stagger-delay-1">
                  {intl.formatMessage({ id: 'login-redirect-hint' })}
                </Typography>
              )}
              {/*<Avatar className={classes.avatar}>*/}
              {/*  <LockOutlinedIcon />*/}
              {/*</Avatar>*/}
              <form className={classes.form} noValidate>
                <div className="stagger-item stagger-delay-2" style={{ width: '100%' }}>
                  <TextField
                    variant="outlined"
                    margin="none"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange.bind(this)}
                    required
                    autoComplete="username email"
                    fullWidth
                    id="email"
                    className={classes.logindetails}
                    disabled={inputDisabled}
                    label={intl.formatMessage({ id: 'Login Email' })}
                    slotProps={{
                      input: {
                        classes: {
                          root: classes.inputBase,
                          input: classes.input
                        }
                      },
                      inputLabel: { className: classes.inputLabel }
                    }}
                  />
                  {this.state.err.email ? (
                    <span className="error_field">{intl.formatMessage({ id: this.state.err.email })}</span>
                  ) : (
                    ''
                  )}
                </div>

                <div className="stagger-item stagger-delay-3" style={{ width: '100%' }}>
                  {this.state.loginMode === 'password' ? (
                    <Box style={{ marginTop: 4 }}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="password"
                        label={intl.formatMessage({ id: 'Password' })}
                        type="password"
                        id="password"
                        value={this.state.password}
                        onChange={this.handleChange.bind(this)}
                        required
                        autoComplete="current-password"
                        className={classes.logindetails}
                        disabled={inputDisabled}
                        slotProps={{
                          input: {
                            classes: {
                              root: classes.inputBase,
                              input: classes.input
                            }
                          },
                          inputLabel: { className: classes.inputLabel }
                        }}
                      />

                      {this.state.err.password ? (
                        <span className="error_field">{intl.formatMessage({ id: 'password-required' })}</span>
                      ) : (
                        ''
                      )}

                      <Box
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '0 2px',
                          margin: '12px 0 8px 0'
                        }}
                      >
                        <Box style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: 12 }}>
                          {!NativeOrWeb.isNativePlatform() && (
                            <Box
                              component="label"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexShrink: 0,
                                whiteSpace: 'nowrap',
                                cursor: inputDisabled ? 'default' : 'pointer',
                                marginBottom: 0
                              }}
                            >
                              <Checkbox
                                checked={this.state.staySignedIn}
                                onChange={e => this.setState({ staySignedIn: e.target.checked })}
                                color="primary"
                                disabled={inputDisabled}
                                style={{ padding: 0, marginRight: 8 }}
                              />
                              <Typography
                                color="primary"
                                style={{
                                  fontSize: 16,
                                  whiteSpace: 'nowrap',
                                  lineHeight: '24px',
                                  position: 'relative',
                                  top: 1
                                }}
                              >
                                {intl.formatMessage({ id: 'stay-signed-in' })}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        <Box
                          onClick={this.toggleLoginMode}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flexShrink: 0
                          }}
                        >
                          <SyncAltIcon color="primary" style={{ fontSize: 16, marginRight: 4 }} />
                          <Typography
                            color="primary"
                            style={{ fontSize: 16, whiteSpace: 'nowrap', lineHeight: '24px' }}
                          >
                            {intl.formatMessage({ id: 'use-one-time-code' })}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box style={{ marginTop: 4 }}>
                      <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 2px', marginBottom: 12 }}>
                        <Box
                          onClick={this.toggleLoginMode}
                          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        >
                          <SyncAltIcon color="primary" style={{ fontSize: 16, marginRight: 4 }} />
                          <Typography color="primary" style={{ fontSize: 16 }}>
                            {intl.formatMessage({ id: 'use-password' })}
                          </Typography>
                        </Box>
                      </Box>
                      <Grid
                        container
                        sx={{
                          alignItems: 'stretch',
                          mb: 1.5
                        }}
                      >
                        <Grid size={7}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            name="otc"
                            label={intl.formatMessage({ id: 'one-time-code' })}
                            type="number"
                            id="otc"
                            value={this.state.otc}
                            onChange={this.handleChange.bind(this)}
                            required
                            disabled={inputDisabled}
                            className={classes.logindetails}
                            style={{ marginBottom: 0 }}
                            slotProps={{
                              input: {
                                classes: {
                                  root: classes.inputBase,
                                  input: classes.input
                                }
                              },
                              inputLabel: { className: classes.inputLabel },
                              htmlInput: { maxLength: 6 }
                            }}
                          />
                        </Grid>
                        <Grid size={5} style={{ paddingLeft: 12, display: 'flex' }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            onClick={this.requestOTC.bind(this)}
                            disabled={inputDisabled || this.state.otcCooldown > 0}
                            className={classes.otcButton}
                            style={{ height: '100%' }}
                          >
                            {this.state.otcCooldown > 0
                              ? `${this.state.otcCooldown}s`
                              : intl.formatMessage({ id: 'send-code' })}
                          </Button>
                        </Grid>

                        {this.state.err.otc ? (
                          <span className="error_field">{intl.formatMessage({ id: this.state.err.otc })}</span>
                        ) : (
                          ''
                        )}
                      </Grid>
                    </Box>
                  )}
                </div>

                <div className="stagger-item stagger-delay-4" style={{ width: '100%', marginTop: 8 }}>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      alignItems: 'center'
                    }}
                  >
                    <Grid style={{ flexGrow: 1 }}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={this.submitForm.bind(this)}
                      >
                        {intl.formatMessage({ id: 'LOGIN' })}
                      </Button>
                    </Grid>

                    {isBiometricSet && (
                      <Grid>
                        <Button
                          variant="outlined"
                          color="primary"
                          disabled={inputDisabled || forceDisableBioAuth}
                          onClick={this.biometricLogin}
                          style={{ minWidth: 'unset', width: 44, height: 44, borderRadius: '12px' }}
                        >
                          <FingerprintIcon style={{ fontSize: 24 }} />
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </div>

                <div className="stagger-item stagger-delay-5" style={{ width: '100%', marginTop: 8 }}>
                  <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 2px' }}>
                    <Typography
                      color="primary"
                      style={{ cursor: 'pointer', fontSize: 16 }}
                      onClick={() => history.push('/forgot_password')}
                    >
                      {intl.formatMessage({ id: 'forgot-password' })}
                    </Typography>
                  </Box>

                  <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 16 }}>
                    <div className="social-btn-hover">
                      <AppleLoginButton
                        intl={intl}
                        loginUser={creds => this.props.loginUser({ ...creds, staySignedIn: this.state.staySignedIn })}
                        loginPhase={this.props.loginPhase}
                        loginMessage={this.props.loginMessage}
                        userDetails={this.props.userDetails}
                        disabled={inputDisabled}
                      />
                    </div>
                    <div className="social-btn-hover">
                      <GoogleLoginButton
                        intl={intl}
                        loginUser={creds => this.props.loginUser({ ...creds, staySignedIn: this.state.staySignedIn })}
                        loginPhase={this.props.loginPhase}
                        loginMessage={this.props.loginMessage}
                        userDetails={this.props.userDetails}
                        disabled={inputDisabled}
                      />
                    </div>
                    <div className="social-btn-hover">
                      <WechatLoginButton
                        intl={intl}
                        loginUser={creds => this.props.loginUser({ ...creds, staySignedIn: this.state.staySignedIn })}
                        loginPhase={this.props.loginPhase}
                        loginMessage={this.props.loginMessage}
                        loginMessageExtras={this.props.loginMessageExtras}
                        userDetails={this.props.userDetails}
                        disabled={inputDisabled}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Grid>
          <Grid size={12} className={classes.bottomWrapper}>
            {!NativeOrWeb.isIOSPlatform() && (
              <div className="btn-signUp stagger-item stagger-delay-5" style={{ marginTop: 12 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.signupButton}
                  onClick={() => {
                    history.push('/userType');
                  }}
                >
                  {intl.formatMessage({ id: 'SIGN UP HERE' })}
                </Button>
              </div>
            )}
            <Box style={{ marginTop: 8 }} className="stagger-item stagger-delay-5">
              <TermsAndPolicyTypography />
            </Box>
          </Grid>
        </LoginBannerContainer>
      </React.Fragment>
    );
  }
}

export default withStyles(LoginForm, LoginStyles);
